import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { parcelTypeOptions } from './constants'

const ParcelTypeSelector = ({ onChange, value = [] }) => {
  const { t } = useTranslation()

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <ComboBox
      value={value || []}
      label={t('Tipo de envío')}
      fullWidth
      multiple
      handleChange={handleChange}
      menuItems={parcelTypeOptions.map(option => ({ label: t(option.label), value: option.value }))}
      placeholder={t('Todos')}
    />
  )
}

export default ParcelTypeSelector
